import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { Country } from '../country';
import { Gender } from '../gender';
import { HttpService } from '../service/http.service';
import { Language } from '../language';
import { Student } from '../student';
import { StudentComment } from '../student-comment';

@Component({
  selector: 'app-student-edit',
  templateUrl: './student-edit.component.html',
  styleUrls: ['./student-edit.component.css']
})
export class StudentEditComponent implements OnInit {

  selectedStudent: Student | undefined;
  studentForm: FormGroup | undefined;
  languages: Language[] = [];
  genders: Gender[] = [];
  nationalities: Country[] = [];
  responseList = [
    {label: "No preference", value: null},
    {label: "Yes", value: true},
    {label: "No", value: false}
  ];
  comments: StudentComment[] = [];
  commentForm: FormGroup | undefined;

  constructor(
    private route: ActivatedRoute,
    private httpService: HttpService,
    private builder: FormBuilder,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    let studentId = Number(this.route.snapshot.paramMap.get("studentId"));
    this.httpService.getStudentById(studentId).subscribe(student => {
      this.selectedStudent = student;
      this.studentForm = this.builder.group({
        firstName: this.selectedStudent.firstName,
        lastName: this.selectedStudent.lastName,
        language: this.selectedStudent.language,
        gender: this.selectedStudent.gender,
        birthday: this.selectedStudent.birthDay,
        nationality: this.selectedStudent.nationality,
        mobile: this.selectedStudent.mobileNumber,
        phoneNumber: this.selectedStudent.phoneNumber,
        email: this.selectedStudent.email,
        address: this.selectedStudent.address,
        postCode: this.selectedStudent.postalCode,
        city: this.selectedStudent.city,
        country: this.selectedStudent.country,
        allergies: this.selectedStudent.allergies,
        hobbies: this.selectedStudent.hobbies,
        specialDiet: this.selectedStudent.specialDiet,
        smokingOk: this.selectedStudent.smokingOk,
        kidsOk: this.selectedStudent.kidsOk,
        petsOk: this.selectedStudent.petOk,
        otherPreference: this.selectedStudent.otherPreference
      });
      this.initComments(student.id!);
    });
    this.commentForm = this.builder.group({
      body: ""
    });
    
    this.httpService.getLanguages().subscribe(res => this.languages = res);
    this.httpService.getNationalities().subscribe(res => this.nationalities = res);
    this.httpService.getGenders().subscribe(res => this.genders = res);
  }

  updateStudent(){
    this.selectedStudent!.firstName = this.studentForm!.value.firstName;
    this.selectedStudent!.lastName = this.studentForm!.value.lastName;
    this.selectedStudent!.language = this.studentForm!.value.language;
    this.selectedStudent!.gender = this.studentForm!.value.gender;
    this.selectedStudent!.birthDay = moment(this.studentForm!.value.birthDay).utc(true);
    this.selectedStudent!.nationality = this.studentForm!.value.nationality;
    this.selectedStudent!.mobileNumber = this.studentForm!.value.mobile;
    this.selectedStudent!.phoneNumber = this.studentForm!.value.phoneNumber;
    this.selectedStudent!.email = this.studentForm!.value.email;
    this.selectedStudent!.address = this.studentForm!.value.address;
    this.selectedStudent!.postalCode = this.studentForm!.value.postCode;
    this.selectedStudent!.city = this.studentForm!.value.city;
    this.selectedStudent!.country = this.studentForm!.value.country;
    this.selectedStudent!.allergies = this.studentForm!.value.allergies;
    this.selectedStudent!.hobbies = this.studentForm!.value.hobbies;
    this.selectedStudent!.specialDiet = this.studentForm!.value.specialDiet;
    this.selectedStudent!.smokingOk = this.studentForm!.value.smokingOk;
    this.selectedStudent!.kidsOk = this.studentForm!.value.kidsOk;
    this.selectedStudent!.petOk = this.studentForm!.value.petsOk;
    this.selectedStudent!.otherPreference = this.studentForm!.value.otherPreference;

    this.httpService.putStudent(this.selectedStudent!).subscribe(() => {
      console.log("success");
      this.addSuccess("Success", "Student updated");
    }, error => {
      this.addError("Error", error.message);
    });
  }

  
  addSuccess(summary: string, detail: string) {
    this.messageService.add({ severity: 'success', summary: summary, detail: detail });
  }

  addError(summary: string, detail: string) {
    this.messageService.add({ severity: 'error', summary: summary, detail: detail });
  }

  initComments(studentId: number){
    this.httpService.getStudentComments(studentId).subscribe(res => {
      this.selectedStudent!.studentComments = res;
    });
  }

  postComment(){
    let comment = new StudentComment(
      this.commentForm!.value.body
    );
    this.httpService.postStudentComment(comment, this.selectedStudent!.id!).subscribe(() => {
      this.addSuccess("Success", "Comment is successfully posted");
      this.initComments(this.selectedStudent!.id!);
    });
  }
}
